// extracted by mini-css-extract-plugin
export default {"headerArea":"styles_headerArea__GjIIi","headTitle":"styles_headTitle__WsE-J","infoIcon":"styles_infoIcon__eHsWz"};